import styled from 'styled-components';

const DigitalWrapper = styled.div`
  background-image: url(${({ src }) => src});
  background-size: 100%;
  border-bottom-left-radius: 20px;
  border-bottom-right-radius: 20px;
  display: flex;
  height: calc(100% - 42px);
  justify-content: center;
  margin: 43px auto 0;
  width: 100%;
`;

export { DigitalWrapper };
